import { render, staticRenderFns } from "./summaryOpinionsToProject.vue?vue&type=template&id=4fe9c7f3&scoped=true"
import script from "./summaryOpinionsToProject.vue?vue&type=script&lang=js"
export * from "./summaryOpinionsToProject.vue?vue&type=script&lang=js"
import style0 from "./summaryOpinionsToProject.vue?vue&type=style&index=0&id=4fe9c7f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe9c7f3",
  null
  
)

export default component.exports